import { IconChevron, Text, TextLinkButton } from 'braid-design-system';
import type React from 'react';

type BackButtonProp = {
  onClick: () => void;
  children: React.ReactNode;
};

export const BackButton = ({ onClick, children }: BackButtonProp) => (
  <Text>
    <TextLinkButton onClick={onClick}>
      <IconChevron direction="left" /> {children}
    </TextLinkButton>
  </Text>
);
